export default number => {
  return number
    .trim()
    .replace(/,/g, "")
};
    